import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import AppContext from "../../AppContext";
import InputText from "../../helpers/InputText";
import MenuTable from "../../helpers/MenuTable";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import InputLegend from "../../helpers/InputLegend";
import InputTextArea from "../../helpers/InputTextArea";
import InputColor from "../../helpers/InputColor";
import InputCombo from "../../helpers/InputCombo";
import InputInteger from "../../helpers/InputInteger";
import InputTime from "../../helpers/InputTime";
import InputDate from "../../helpers/InputDate";
import InputKidsMulti from "../../helpers/InputKidsMultiE";



export default function Psychologist(props)
{

    const tabRef = useRef(0);
    const tab2Ref = useRef(0);

 
    const [filterParam, setFilterParam] = useState({  

        men_dziennik_id: props.id,
        d_imie_nazwisko: '',
      
        
      
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },

        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);
    const [kids, setKids] = useState(null);


      const [legend, setLegend] = useState([
        {
            cls:'color_deleted',
            title: 'dziecko niewidoczne w dzienniku',
            filter: {  filed: "archiwalne", set: "1", typ: "combo"  },
        },
    ]);


     const [errTab, setErrTab] = useState([]);  //z info od serwera.. 


     const defRow = {
          id: -1,
          men_dziennik_id: props.id,
          p_dziecko_id: -1,         
          data_objecia: '',         
          data_zakonczenia: '',         
          podstawa: '',         
          forma_pomocy: '',         
          dodatkowe_informacje: '',         
       };

     const [row, setRowX] = useState(defRow);

    
    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );

    const changeView = (e ) => {

       
        var v = e.target.getAttribute('v');
        var id = e.target.getAttribute('id');

        setView({...view, ["v"]:v, ["id"]:id });

        if(v != 'edit')
        {
            setRowX(defRow);
        }
    


    }



       const valChangeListenerRow = (filedName, val, correct, msg) => {         
             console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
                        
         
             setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );              
        }   


    
    const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );

             if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
           

            props.mainView.writeFilter(filedName, val);
        }

    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }

            
      const filterClear = () => {
 
 
       
            setFilterParam({
 
               men_dziennik_id: props.id,
               d_imie_nazwisko: '',                
                        

                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },


                limit: 50,
                page: 1,
                show: true, 
            });
            setTab(null);
        }


 const filterApprove = () => {   
     setTab(null)     
 }




 
    const getTab = () => {
            
        
            props.mainView.setProgress(-2);
        

            fetch( Config.url + '/rest_v1_men,ps', {
                method: 'POST', 
                body: JSON.stringify(filterParam), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            setTab(res.result);             

                            if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
            });
                    

            return false;
    }

 const getKids = () => {
            
        
            props.mainView.setProgress(-2);
        
            var req = {
                   men_dziennik_id: props.id,
            };

            fetch( Config.url + '/rest_v1_men,dz_kids', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            setKids(res.result);             
             
                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
            });
                    

            return false;
    }


     const saveData = () => {
            
        
        if(row.p_dziecko_id.length < 1 || row.p_dziecko_id < 1)
        {
              props.mainView.showDialog( "Error", "Wybierz dziecko", "ok" , null);  
            return;
        }

    if(row.data_objecia.length < 2  )
        {
              props.mainView.showDialog( "Error", "Podaj datę objęcia pomocą", "ok" , null);  
            return;
        }

         if(row.podstawa.length < 2  )
        {
              props.mainView.showDialog( "Error", "Podaj podstawę objęcia pomocą", "ok" , null);  
            return;
        }

          if(row.forma_pomocy.length < 2  )
        {
              props.mainView.showDialog( "Error", "Podaj formę pomocy", "ok" , null);  
            return;
        }


            props.mainView.setProgress(-2);
        

            fetch( Config.url + '/rest_v1_men,ps_set', {
                method: 'POST', 
                body: JSON.stringify(row), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            getTab();             
                            setRowX(defRow);
                            setView({v:"list",id:-1});
                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
            });
                    

            return false;
    }



   if(tab == null)
   {
      setTab([]);
      getTab(); 
      getKids();
      return <div>...</div>
   }



    var viewDialog = null;

 if(view.v == "new")
    {
 

                viewDialog =   <div className="dlg_window dlg_type_xx shadowx">
            
                                    <div className="dlg_title">
                                     Nowy wpis
                                    </div>

                                    <div className="dlg_content_x scroll500">

                                              <div className="form_tab">
                                                
                                                             

                                                             <div className="form_control">
                                                                <div className="fieldName">Dziecko*</div>
                                                                <InputCombo items={kids}     userData={props.userData} value={row.p_dziecko_id} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="p_dziecko_id" placeholder={""} className=' ' req='1' firstUp="0" />
                                                            </div>


                                                   

                                                            <div className="form_control">
                                                                <div className="fieldName">Data objęcia pomocą*</div>
                                                                <InputDate     userData={props.userData} value={row.data_objecia} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="data_objecia" placeholder={""} className=' ' req='1' firstUp="0" />
                                                            </div>
  
                                                            <div className="form_control">
                                                                <div className="fieldName">Data zakończenia</div>
                                                                <InputDate     userData={props.userData} value={row.data_zakonczenia} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="data_zakonczenia" placeholder={""} className=' ' req='0' firstUp="0" />
                                                            </div>

                                                            <div className="form_split"></div>

                                                            <div className="form_control">
                                                                <div className="fieldName">Podstawia objęcia, numer dokumentu, itp.*</div>
                                                                <InputTextArea   userData={props.userData} value={row.podstawa} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="podstawa" placeholder={"Podstawa:"} className=' w400  h50' req='1' firstUp="0" />
                                                            </div>

                                                             <div className="form_split"></div>

                                                            <div className="form_control">
                                                                <div className="fieldName">Forma pomocy*</div>
                                                                <InputTextArea   userData={props.userData} value={row.forma_pomocy} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="forma_pomocy" placeholder={"Forma pomocy:"} className=' w400  h50' req='1' firstUp="0" />
                                                            </div>

  

                                              </div>


                                    <div className="form_split"></div>

                                            <div className="form_control">                                            
                                                <div className="btn" onClick={saveData}>zapisz</div>
                                                &nbsp; &nbsp;
                                                <div className="btn" onClick={changeView}>anuluj</div>
                                            </div>

                                    </div>

                            </div>
    }


    if(view.v == "edit")
    {

        if(row.p_dziecko_id < 0)
        {
            var findInx = -1;

            for(var kk=0;kk<tab.length; kk++)
            {
                if(tab[kk].id == view.id)
                {
                    findInx = kk;break;
                }
            }

            

            setRowX({
                         id:  tab[findInx]['id'],         
                        men_dziennik_id: props.id,
                        p_dziecko_id: tab[findInx]['dziecko']['id'],         
                        data_objecia: tab[findInx]['data_objecia'],         
                        data_zakonczenia: tab[findInx]['data_zakonczenia'],         
                        podstawa: tab[findInx]['podstawa'],         
                        forma_pomocy: tab[findInx]['forma_pomocy'],         
                        dodatkowe_informacje: tab[findInx]['dodatkowe_informacje'],                
                });
        }


          viewDialog =   <div className="dlg_window dlg_type_xx shadowx">
            
                                    <div className="dlg_title">
                                     Nowy wpis
                                    </div>

                                    <div className="dlg_content_x scroll500">

                                              <div className="form_tab">
                                                
                                                             

                                                             <div className="form_control">
                                                                <div className="fieldName">Dziecko*</div>
                                                                <InputCombo items={kids}     userData={props.userData} value={row.p_dziecko_id} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="p_dziecko_id" placeholder={""} className=' ' req='1' firstUp="0" />
                                                            </div>


                                                   

                                                            <div className="form_control">
                                                                <div className="fieldName">Data objęcia pomocą*</div>
                                                                <InputDate     userData={props.userData} value={row.data_objecia} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="data_objecia" placeholder={""} className=' ' req='1' firstUp="0" />
                                                            </div>
  
                                                            <div className="form_control">
                                                                <div className="fieldName">Data zakończenia</div>
                                                                <InputDate     userData={props.userData} value={row.data_zakonczenia} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="data_zakonczenia" placeholder={""} className=' ' req='0' firstUp="0" />
                                                            </div>

                                                            <div className="form_split"></div>

                                                            <div className="form_control">
                                                                <div className="fieldName">Podstawia objęcia, numer dokumentu, itp.*</div>
                                                                <InputTextArea   userData={props.userData} value={row.podstawa} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="podstawa" placeholder={"Podstawa:"} className=' w400  h50' req='1' firstUp="0" />
                                                            </div>

                                                             <div className="form_split"></div>

                                                            <div className="form_control">
                                                                <div className="fieldName">Forma pomocy*</div>
                                                                <InputTextArea   userData={props.userData} value={row.forma_pomocy} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="forma_pomocy" placeholder={"Forma pomocy:"} className=' w400  h50' req='1' firstUp="0" />
                                                            </div>

  

                                              </div>


                                    <div className="form_split"></div>

                                            <div className="form_control">                                            
                                                <div className="btn" onClick={saveData}>zapisz</div>
                                                &nbsp; &nbsp;
                                                <div className="btn" onClick={changeView}>anuluj</div>
                                            </div>

                                    </div>

                            </div>
    }




        return <div>


                    <div className="table_filter">

                        <div className="filter_controll">   
                            <label>Imię i nazwisko: </label>                             
                            <InputText   userData={props.userData}  mainView={props.mainView}   value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Imię i nazwisko: "}     />
                        </div>

                        <div className="filter_btn">                           
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                        </div>

                    </div>


                      <div className="table_widget">    

                            {
                                props.status == "aktywny" &&
                                <div className="btn" onClick={changeView} v="new" id="-1"  > dodaj wpis</div>
                            }                             

                            &nbsp; &nbsp;
                            <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={props.title  } />  
                      </div>

 
                        <div ref={tabRef} className="gohide">
                            <h3>{props.title}, formy pomocy psychologiczno - pedagogicznej</h3>   
                            <table className="table" >

                                        <thead>
                                                <tr className="header">                                                    
                                                    <td className="td_left">LP</td>                                                                                                                                           
                                                    <td className="">Imię i nazwisko</td>                                                                                                                                           
                                                    <td className="">Data objęcia</td>                                               
                                                    <td className="">Podstawa</td>                  
                                                    <td className="td_right">Forma pomocy</td>                                                                                                                                                                                                                                     
                                                                                                                                                                                                                                                                         
                                                                                         
                                                </tr>
                                        </thead>

                                        <tbody>

                                            {
                                                tab.map( (item, ixKey) => {

                                                    var rowStyle = " row ";
                                                    if(ixKey % 2 == 0 )rowStyle = " row2 ";
 

                                                    return <tr className={rowStyle + " " } key={ixKey}>
                                                            <td className="gocenter">{ixKey+1}</td>                                                                                                                                           
                                                            <td className="goleft"> {item.dziecko.imie} {item.dziecko.nazwisko} </td>     
                                                            <td className="gocenter"> {item.data_objecia}</td>                                                                                                                                           
                                                            <td className="goleft">{item.podstawa}</td>                                                                                                                                           
                                                            <td className="goleft">{item.forma_pomocy}</td>                                                                                                                                           
                                                     
                                                          
                                                    </tr>

                                                } )
                                            }

                                        </tbody>

                            </table>

                        </div>

                          <div className="scorll_x">
          

                            <table className="table" >

                                        <thead>
                                                <tr className="header">                                                    
                                                    <td className="td_left">LP</td>                                                                                                                                           
                                                    <td className="">Imię i nazwisko</td>                                                                                                                                           
                                                    <td className="">Data objęcia</td>                                               
                                                    <td className="">Podstawa</td>                  
                                                    <td className="td_right">Forma pomocy</td>                                                                                                                                                                                                                                     
                                                    <td className="td_option"></td>                                                                                                                                                                                                                                     
                                                                                         
                                                </tr>
                                        </thead>

                                        <tbody>

                                            {
                                                tab.map( (item, ixKey) => {

                                                    var rowStyle = " row ";
                                                    if(ixKey % 2 == 0 )rowStyle = " row2 ";
 

                                                    return <tr className={rowStyle + " " } key={ixKey}>
                                                            <td className="gocenter">{ixKey+1}</td>                                                                                                                                           
                                                            <td className="goleft"> {item.dziecko.imie} {item.dziecko.nazwisko} </td>     
                                                            <td className="gocenter"> {item.data_objecia}</td>                                                                                                                                           
                                                            <td className="goleft">{item.podstawa}</td>                                                                                                                                           
                                                            <td className="goleft">{item.forma_pomocy}</td>                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                    

                                                             <MenuTable>
                                                                        <ul>        
                                                                               {
                                                                                props.status == "aktywny" &&
                                                                                <li onClick={changeView}  id={item.id} v="edit"  >edytuj</li>  
                                                                               }                                                              
                                                                                  
                                                                        </ul>                                                               
                                                            </MenuTable>  
                                                          
                                                    </tr>

                                                } )
                                            }

                                        </tbody>

                            </table>
             </div>


             {viewDialog}
             

        </div>
}